module.exports = __webpack_public_path__ + "media/images/guideline/G_04-bd95e404d00427a2b9b2c219298cfb72.jpg";